import "quill/dist/quill.snow.css"
import Quill, {QuillOptionsStatic} from "quill";
import {ImageResize} from 'quill-image-resize-module';
import _ from "lodash";
import {uploadImg} from "@/util/request";

console.log(ImageResize)

Quill.register('modules/imageResize', ImageResize);

// 自定义文字大小
const size = [
    '10px', '12px', '14px', '16px', '18px', '20px', '24px', '26px', '32px', '48px'
]
const SizeStyle = Quill.import('attributors/style/size');
SizeStyle.whitelist = size;
Quill.register(SizeStyle, true);

// 自定义字体
const font = ['宋体', '黑体', '微软雅黑', '楷体', '仿宋', 'Arial', '苹方']
const FontStyle = Quill.import('attributors/style/font');
FontStyle.whitelist = font;
Quill.register(FontStyle);

// 新增行高
const Parchment = Quill.import("parchment");
const lineHeight = ['initial', '1', '1.5', '1.75', '2', '3', '4'];
const LineHeight = new Parchment.Attributor.Style("lineHeight", "line-height", {
    whitelist: lineHeight,
});
Quill.register(LineHeight, true);

const Align = Quill.import('attributors/style/align');
Align.whitelist = ['right', 'center', 'justify'];
Quill.register(Align, true);

type ControlHandler = (this: ControlThis, value: boolean) => void;

interface ControlThis {
    container: HTMLElement,
    quill: Quill,
    controls: Record<string, Record<string, HTMLElement>>,
    handlers: Record<string, ControlHandler>
}

export function createQuill(el: HTMLElement, options: QuillOptionsStatic) {
    const defaultOptions: QuillOptionsStatic = {
        theme: "snow",
        modules: {
            history: {          // Enable with custom configurations
                delay: 2500,
                userOnly: true
            },
            imageResize: {
            },
            toolbar: [
                ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                ['blockquote', 'code-block'],
                [{'header': 1}, {'header': 2}],               // custom button values
                [{'list': 'ordered'}, {'list': 'bullet'}],
                [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
                [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
                [{'direction': 'rtl'}],                         // text direction

                [{'size': ['10px', '12px', false, '16px', '18px', '20px', '24px', '26px', '32px', '48px']}],  // custom dropdown
                [{'header': [1, 2, 3, 4, 5, 6, false]}],
                [{lineHeight}],
                ["link", "image"],
                [{'color': []}, {'background': []}],          // dropdown with defaults from theme
                [{font}],
                [{'align': []}],

                ['clean']                                         // remove formatting button
            ]
        },
    }
    const quill = new Quill(el, _.merge(defaultOptions, options));
    const toolbar = quill.getModule("toolbar");
    // const link: ControlHandler = async (value) => {
    //     if (value) {
    //         const href = await modalPrompt('请输入链接');
    //         if (href) {
    //             quill.format('link', href);
    //         }
    //     } else {
    //         quill.format('link', false);
    //     }
    // }
    // toolbar.addHandler("link", link)

    const image: ControlHandler = async () => {
        const img = await uploadImg();
        if (img) {
            const range = quill.getSelection(true);
            quill.insertEmbed(range.index, 'image', img, Quill.sources.USER);
            quill.setSelection(range.index + 1, 0, Quill.sources.SILENT);
        }
    }
    toolbar.addHandler("image", image)
    return quill;
}
